import { PaginationButton } from "./PaginationButton";
import { PageArrowLeftDis, PageArrowRight } from "../../assets/icons";
import styled from "styled-components";

export const PaginationLayout = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
  activePages,
}) => {
  return (
    <div>
      <PaginationButton
        onClick={() => onPageChange(currentPage - 1, "prev")}
        disabled={currentPage === 1 || isTableDataLoading}
      >
        <ArrowImage
          src={
            currentPage === 1
              ? PageArrowLeftDis
              : PageArrowRight
          }
          alt="left-icon"
        />
      </PaginationButton>
      {activePages.map((pageNo, idx) => (
        <PaginationButton
          disabled={isTableDataLoading}
          key={idx}
          label={pageNo}
          isActive={currentPage === pageNo}
          onClick={() => onPageChange(pageNo)}
        />
      ))}
      <PaginationButton
        onClick={() => onPageChange(currentPage + 1, "next")}
        disabled={currentPage === totalPages || isTableDataLoading}
      >
        <ArrowImage
          src={
            currentPage === totalPages
              ? PageArrowLeftDis
              : PageArrowRight
          }
          alt="right-icon"
        />
      </PaginationButton>
    </div>
  );
};

const ArrowImage = styled.img`
  width: 0.5rem;
  height: 0.5rem;
`;